import { FC } from 'react';
import { Swiper, SwiperProps } from 'swiper/react';

import { galleryContainer } from '@/styles/components/galleries.module.scss';

export const GalleriesList: FC<SwiperProps> = ({
  children,
  style,
  ...props
}) => {
  return (
    <div className={galleryContainer}>
      <Swiper
        slidesPerView="auto"
        spaceBetween={30}
        pagination={{
          clickable: true,
        }}
        className="mySwiper"
        style={style}
        {...props}
      >
        {children}
      </Swiper>
    </div>
  );
};
